<div class="odv">

  <!-- Top bar: sponsor badge alineado a la derecha -->
  @if (labelConfig().showLabel) {
  <div class="odv__header">
    <app-ui-sponsor-badge [variant]="labelConfig().color" [label]="offer().textLabel.slice(0, 30)"
      [icon]="labelConfig().img" />
  </div>
  }

  <!-- Main info: logo + description + values -->
  <div class="odv__main">
    <div class="odv__logo-col">
      <app-ui-image [src]="logoUrl()" [alt]="offer().company.name" />
      <app-ui-button class="apply-button" variant="tertiary" (pressed)="applyPressed.emit()">
        Aplicar ahora <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </app-ui-button>
    </div>
    <div class="odv__info-col">
      @if (offer().detail.title) {
      <p class="odv__description">{{ offer().detail.title }}</p>
      }
      <app-offer-info-molecule [receiveValue]="offer().card.offerValue ?? ''" [detail1Title]="offer().card.offerDetail1"
        [detail1Value]="offer().card.offerDetail1value" [approxTitle]="offer().card.offerAproxValueTitle ?? ''"
        [captionValue]="offer().card.offerAproxValue ?? ''"
        [additionalBenefits]="offer().detail.additionalBenefits ?? false"
        [benefitsText]="offer().detail.textAdditionalBenefits ?? ''" />
    </div>
  </div>

  <!-- Detail columns: benefits | characteristics | requirements -->
  <div class="odv__columns">
    @if (offer().detail.benefits?.length) {
    <div class="odv__col">
      <h3 class="odv__col-title">{{ offer().detail.titleBenefits }}:</h3>
      <hr class="odv__col-line" />
      @for (benefit of (offer().detail.benefits ?? []); track benefit) {
      <app-ui-check-list-item>{{ benefit }}</app-ui-check-list-item>
      }
    </div>
    }
    @if (offer().detail.property?.length) {
    <div class="odv__col">
      <h3 class="odv__col-title">Características de la oferta:</h3>
      <hr class="odv__col-line" />
      @for (prop of (offer().detail.property ?? []); track prop) {
      <app-ui-check-list-item>{{ prop.value }}</app-ui-check-list-item>
      }
    </div>
    }
    <div class="odv__col">
      <h3 class="odv__col-title">Requisitos de la oferta:</h3>
      <hr class="odv__col-line" />
      @for (req of (offer().detail.requirements ?? []); track req) {
      <app-ui-check-list-item>{{ req }}</app-ui-check-list-item>
      }
      @if (scoreText()) {
      <div class="odv__score-row">
        <i class="fa fa-check" aria-hidden="true"></i>
        <span>Puntaje requerido:</span>
        <span class="score-badge" [ngClass]="scoreBadgeClass()">{{ scoreText() | uppercase }}</span>
      </div>
      }
    </div>
  </div>
  <div class="odv__message-description">
    @for (paragraph of messageDescription; track $index) {
    <p [innerHTML]="paragraph"></p>
    }
  </div>

</div>